module.exports = __webpack_public_path__ + "static/media/bar-full.c07819e6.png";